{
  "R": [0, 86, 166, 255],
  "G": [32, 92, 156, 233],
  "B": [76, 108, 117, 69],
  "A": [0, 56, 80, 88],
  "I": [0, 64, 192, 255]
}
